import React from "react";

const SmoothScrollLink = ({ to, offset = 0, children, className, style, ...rest }) => {
  const scrollToId = (id, offsetPx = 0) => {
    const el = document.getElementById(id);
    if (!el) return false;
    const top = el.getBoundingClientRect().top + window.pageYOffset - offsetPx;
    window.scrollTo({ top, behavior: "smooth" });
    return true;
  };

  const tryScrollWithRetry = (id, offsetPx = 0, attempts = 0, maxAttempts = 12) => {
    const ok = scrollToId(id, offsetPx);
    if (ok) return;
    if (attempts >= maxAttempts) return;
    setTimeout(() => tryScrollWithRetry(id, offsetPx, attempts + 1, maxAttempts), 100);
  };

  const handleClick = (e) => {
    e.preventDefault();
    tryScrollWithRetry(to, offset);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      tryScrollWithRetry(to, offset);
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className={className}
      style={{ cursor: "pointer", ...style }}
      {...rest}
      aria-controls={to}
    >
      {children}
    </div>
  );
};

export default SmoothScrollLink;
